<template>
    <div class="reminder-detail-page">
        <div class="head">
            <i class="back"
               @click="back()"></i>
            <p class="title">选择班级</p>
        </div>
        <div class="school-list">
            <div class="school-item"
                 v-for="(item,index) in list"
                 v-show="item.sf_unit.length"
                 :key="index">
                <div class="school-name">{{item.school_name}}</div>
                <div class="unit-list"
                     v-if="item.sf_unit">
                    <div class="unit-item"
                         v-for="(item2,index2) in item.sf_unit"
                         :key="index2">
                        <p>{{item2.unit_name}}</p>
                        <span :class="item2.active?'active':''"
                              @click="handleChoose(item2)"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="fix-btn">
            <p @click="toChooseStu">单独发给学生></p>
            <div class="btn"
                 @click="selectUnit"><span>确定</span></div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            //从缓存中读取已选择的班级
            reminderUnits: JSON.parse(localStorage.getItem('reminderUnits')),
            list: [],
            from: Number(this.$route.query.from)||0,
        }
    },
    created () {
        this.getUnitList()
    },
    methods: {
        getUnitList () {
            this.$http.post(API_URL_BASE_API + '/unit/region/class_list/').then(res => {
                if (res.data.response == 'ok') {
                    res.data.data.school_list.forEach(e => {
                        e.sf_unit = []
                        if (e.units.length) {
                            e.units.forEach((item, index, array) => {
                                if(this.from==1){
                                    if (array[index].sid === 11 || array[index].sid === 14) {
                                        //仅保留带书法的班级
                                        item.active = false;
                                        e.sf_unit.push(item);
                                    }
                                }else{
                                    item.active = false;
                                    e.sf_unit.push(item);
                                }
                            })
                        }
                    })
                    this.list = res.data.data.school_list
                    //缓存里存在的班级 为已选中状态
                    this.list.forEach(e => {
                        e.sf_unit.forEach(j => {
                            if (this.reminderUnits) {
                                this.reminderUnits.forEach(k => {
                                    if (j.unit_class_id == k.unit_class_id) {
                                        j.active = true
                                    }
                                })
                            }

                        })
                    })
                }
            })
        },
        //选中班级
        handleChoose (item) {
            if (item.stu_nums) {
                item.active = !item.active
            } else {
                layer.tips('该班级下暂无学生')
            }
        },
        //确定
        selectUnit () {
            let _units = []
            this.list.forEach(e => {
                e.sf_unit.forEach(j => {
                    if (j.active) {
                        _units.push(j)
                    }
                })

            })
            if (!_units.length) {
                layer.tips('请选择班级')
                return
            }
            localStorage.removeItem('stuList')
            localStorage.setItem('reminderUnits', JSON.stringify(_units))
            this.$router.go(-1)
        },
        //单独发给学生
        toChooseStu () {
            this.$router.push('/reminder/chooseStu')
        }
    },

}
</script>

<style lang="scss" scoped>
.reminder-detail-page {
    padding-top: 96px / $ppr;
    padding-bottom: 185px / $ppr;
}
.head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;

    .back {
        position: absolute;
        top: 0;
        left: 0;
        width: 76px / $ppr;
        height: 96px / $ppr;
        background: url(../img/choose_back.png) no-repeat center;
        background-size: 18px / $ppr 34px / $ppr;
    }

    .title {
        width: 100%;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 34px / $ppr;
        color: #fff;
        text-align: center;
    }
    .send {
        position: absolute;
        top: 0;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        right: 24px / $ppr;
        z-index: 10;
        font-size: 30px / $ppr;
        color: #fff;
    }
    .gary {
        color: #e8e8e8;
    }
}
.school-list {
    padding: 24px / $ppr;
    .school-item {
        margin-bottom: 24px / $ppr;
        .school-name {
            color: #5e89ef;
            background: #e8f0fd url("../release/img/icon-school.png") no-repeat
                24px / $ppr center;
            background-size: 42px / $ppr 42px / $ppr;
            padding: 24px / $ppr 24px / $ppr 24px / $ppr 80px / $ppr;
            border-radius: 24px / $ppr 24px / $ppr 0 0;
        }
        .unit-list {
            .unit-item {
                background: #fff;
                padding: 24px / $ppr;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1px / $ppr solid #e8e8e8;
                span {
                    display: inline-block;
                    width: 30px / $ppr;
                    height: 30px / $ppr;
                    background: url("../release/img/icon_unchecked.png")
                        no-repeat;
                    background-size: 100% 100%;
                }
                .active {
                    background: url("../release/img/icon_select.png") no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
    }
}
.fix-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    p {
        text-align: center;
        color: #5e89ef;
        margin-bottom: 20px / $ppr;
    }
    .btn {
        background: #fff;
        padding: 24px / $ppr;
        span {
            display: block;
            background: #5e89ef;
            color: #fff;
            font-size: 30px / $ppr;
            line-height: 80px / $ppr;
            border-radius: 40px / $ppr;
            text-align: center;
        }
    }
}
</style>